export default "__VITE_ASSET__e3e9ad67__"